// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import store from './vuex/store';
import api from './api/index';
import md5 from "js-md5";
import getToken from './lib/getToken';
import isFirst from './lib/isFirstPage';
import Nprogress from 'nprogress';
import 'nprogress/nprogress.css';
import { MessageBox } from 'element-ui';
var $base64 = require("js-base64").Base64;
import VerticalToggle from '../src/lib/verticalToggle'
import VideoPlayer from 'vue-video-player'
import 'viewerjs/dist/viewer.css';
import Viewer from 'v-viewer';
Vue.component(VerticalToggle.name, VerticalToggle)
require('video.js/dist/video-js.css')
require('vue-video-player/src/custom-theme.css')
Viewer.setDefaults({zIndexInline: 9999})
import Global from './api/global'//检测同一个浏览器登录两个帐号
import jsPlumb from 'jsplumb'
import {message} from '../src/lib/resetMessage.js';
import Clipboard from 'clipboard'; 
import promptMailbox from './components/exam2/promptMailbox.vue';
import veinQuest from './assets/js/veinQuest.json';
Vue.prototype.Clipboard=Clipboard;
Vue.prototype.$axios = api;
Vue.prototype.$md5 = md5;
Vue.prototype.$base64 = $base64;
Vue.prototype.$jsPlumb = jsPlumb.jsPlumb
Vue.prototype.veinQuest = veinQuest
Vue.config.productionTip = false;
Vue.use(Viewer);
Vue.use(ElementUI);
Vue.use(VideoPlayer);
Vue.prototype.$message = message;
Vue.component('promptMailbox', promptMailbox)
// 所有复制链接访问跳转到登陆
// if(window.location.href.indexOf('/login')==-1 && isFirst.isFirstHistory()){
//     router.push({
//         path: '/login',
//     })
// }else if(window.location.href.indexOf('/login')!=-1){
//     isFirst.isFirstHistory()
// }
if(localStorage.getItem('roadName')&&localStorage.getItem('roadName')=='Dr'){
    // document.title = '中国音乐学院博士研究生招生网'
    document.title = '中国音乐学院研究生招生考试网'
}else{
    document.title = '中国音乐学院硕士研究生招生复试报名网'
}
getToken.getToken_http()
router.beforeEach((to, from, next) => {
  Nprogress.start()
  let tokenTime = localStorage.getItem('tokenExpiryTime-web')
  let Expiry = $base64.decode(tokenTime)
  const nn = +new Date();
  if(Expiry && nn >= Expiry){
      localStorage.removeItem('secretKey-web');
      localStorage.removeItem('account-web');
      localStorage.removeItem('userToken-web');
      localStorage.removeItem('tokenExpiryTime-web');
      MessageBox.alert('登录过期，请重新登录。', '提示', {
        confirmButtonText: '确 定',
        center: true,
        type: 'error',
        callback: action => {
          Nprogress.done()
          getToken.getToken_http()
          let str = window.location.href; 
          let bat = str.match(/\/web\/(\S*)\/login/)[1]
          let orgID = bat.split('/')[bat.split('/').length-1]
          str = bat? bat.length:0
          if(sessionStorage.getItem('orgId')||str>3){//测评
            next({
              path: `/${sessionStorage.getItem('orgId')? sessionStorage.getItem('orgId'):orgID}/login`,
              query: {
                phone:sessionStorage.getItem('phone')? sessionStorage.getItem('phone'):''
              }
            });
          }else{
            next('/login');
          }
        }
      });
  } else {
    Nprogress.done()
    if (to.matched.length === 0) {
      next('/404')
    } else {
      next()
    }
  }
})

//实时监听
Vue.prototype.resetSetItem = function (key, newVal) {
    var newStorageEvent = document.createEvent('StorageEvent');  // 创建一个StorageEvent事件
    const storage = {
        setItem: function (k, val) {
            sessionStorage.setItem(k, val);
            newStorageEvent.initStorageEvent('setItem', false, false, k, null, val, null, null);// 初始化创建的事件
            window.dispatchEvent(newStorageEvent)  // 派发对象
        }
    }
    return storage.setItem(key, newVal);
}
// 检测两个登录页面登录不同账号
window.addEventListener("visibilitychange",function(){ //这个方法是监测浏览器窗口发生变化的时候执行
  if (document.hidden == false && Global.loginUid && Number(Global.loginUid) != Number($base64.decode(window.localStorage.getItem('uid-web')))) {
    Global.loginUid = $base64.decode(window.localStorage.getItem('uid-web')) //只有当初始创建的aaa不等于localStorage里面的userId的时候去覆盖掉这个aaa
    if(sessionStorage.getItem('orgId')){//测评
        router.push({
          path: `/${sessionStorage.getItem('orgId')}/login`,
          query: {
              phone:sessionStorage.getItem('phone')? sessionStorage.getItem('phone'):''
          }
        })
    }else{
        router.push({
          path: '/login',
        })
    }
  }
});

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js